import React from 'react'
import { Button } from '../../buttons/Button/Button'
import {
    StyledMessageBannerWrapper,
    StyledSubscriberMessage,
    StyledMessageCTA,
    StyledIconComment,
    StyledIconPremium,
    StyledMessageBanner,
    StyledMessageBannerGroup,
    StyledButtonWrapper,
} from './MessageBanner.styled'
import { AuthenticationProvider } from '../../user-registration/authentication/AuthenticationProvider'
import { ThemeMargins } from '../../__styling/settings/metrics'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { AuthenticationState } from '@news-mono/web-common'
import { THEWEST_ALL } from '../../user-registration/entitlements/common'

export type ArrowStyle = 'solid-arrow'

export interface MessageBannerProps {
    icon?: 'comment' | 'subscriber'
    id?: string
    verticalSpacing?: keyof ThemeMargins | undefined
    onEvent: (event: any) => void
    connector?: ArrowStyle
}

export const MessageBanner: React.FC<MessageBannerProps> = ({
    icon,
    id,
    children,
    verticalSpacing,
    onEvent,
    connector,
}) => {
    const { entitlements, isLoggedIn } = useSelector<
        AppState,
        AuthenticationState
    >((state) => state.authentication)

    const returningUser = isLoggedIn && !entitlements?.includes(THEWEST_ALL)

    return (
        <StyledMessageBanner
            id={id}
            verticalSpacing={verticalSpacing}
            connector={connector}
        >
            <StyledMessageBannerWrapper>
                {icon === 'comment' && <StyledIconComment />}
                {icon === 'subscriber' && <StyledIconPremium />}
                <StyledMessageCTA>{children}</StyledMessageCTA>
                {!returningUser && (
                    <StyledMessageBannerGroup>
                        <StyledSubscriberMessage>
                            Are you already a subscriber?
                        </StyledSubscriberMessage>
                        <StyledButtonWrapper>
                            <AuthenticationProvider onEvent={onEvent}>
                                {({ onLoginClick }) => (
                                    <Button
                                        onClick={onLoginClick}
                                        onEvent={onEvent}
                                        buttonWidth="wide"
                                    >
                                        Login
                                    </Button>
                                )}
                            </AuthenticationProvider>
                        </StyledButtonWrapper>
                    </StyledMessageBannerGroup>
                )}
            </StyledMessageBannerWrapper>
        </StyledMessageBanner>
    )
}

MessageBanner.displayName = 'MessageBanner'
